import React from 'react';
import Chip from '@material-ui/core/Chip';

function HyvitysChip() {
    return <Chip
        size="small"
        label="HYVITYSLASKU"
        variant="outlined"
        style={{ marginLeft: 10, color: "limegreen" }}
    />
}

export default HyvitysChip;